export enum RAGStatus {
  RED = 'error',
  AMBER = 'warning',
  GREEN = 'success',
}

export enum ColumnType {
  EMAIL = 'email',
  DATE = 'date',
  OTHER = 'others',
}

export enum ConsentFileType {
  OPT_IN = 'opt-in',
  OPT_OUT = 'opt-out',
  CONFIRMED_OPT_IN = 'confirmed-opt-in',
}

export interface Column {
  type: ColumnType;
  heading: string;
  rows: string[];
}
export interface Red {
  type: RAGStatus;
  message: string;
  errors: string[];
  consentType: ConsentFileType;
}

export interface Amber {
  type: RAGStatus;
  message: string;
  columns: Column[];
  consentType: ConsentFileType;
}

export interface Green {
  type: RAGStatus;
  message: string;
  fileData: string;
  emailCount: number;
  consentType: ConsentFileType;
}

export type ConsentFileAnalysedStatus = Red | Green | Amber;

export interface Status {
  code: ConsentFileAnalysedStatus;
  errors: string[];
}

export interface ConsentFileData {
  fileName: string;
  status: ConsentFileAnalysedStatus;
}

export class InvalidLineError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class InvalidDelimiterError extends Error {
  public constructor(message: string) {
    super(message);
  }
}

export class NoValidEmailColumnsFoundsError extends Error {
  public constructor(message: string) {
    super(message);
  }
}
